export default "__VITE_ASSET__d12M4RrX__"